import React from 'react';
import './src/styles/index.css';
import { StoreContextProvider, SettingsProvider, LocaleContext, ShopContext } from './src/contexts';

import Layout from './src/components/layout/Layout';

export const wrapRootElement = ({ element }) => (
  <StoreContextProvider>{element}</StoreContextProvider>
);

// Fungsi untuk tracking Klaviyo setiap kali route berubah
export const onRouteUpdate = ({ location }) => {
  console.log("pathname: "+ location.pathname);
  if (typeof window !== "undefined" && window._learnq) {
    // Mengirim event 'Viewed Page' ke Klaviyo dengan informasi halaman saat ini
    window._learnq.push(["track", "Viewed Page", {
      PageName: location.pathname, 
    }]);
  }
};

export const wrapPageElement = ({
  element,
  props: {
    pageContext: {
      shopMenuHeader,
      pageType,
      allLocaleSlugs,
      node_locale,
      allProductsTitleSlug,
      navbarColor,
      protectionProducts,
    },
  },
}) => (
  <SettingsProvider allLocaleSlugs={allLocaleSlugs}>
    <LocaleContext.Provider value={{ lang: node_locale }}>
      <ShopContext.Provider value={{ protectionProducts }}>
        <Layout
          allProductsTitleSlug={allProductsTitleSlug}
          shopMenuHeader={shopMenuHeader}
          pageType={pageType}
          navbarColor={navbarColor}
        >
          {element}
        </Layout>
      </ShopContext.Provider>
    </LocaleContext.Provider>
  </SettingsProvider>
);
